module.exports = __webpack_public_path__ + "static/img/51_cat.72c0a9d8.jpg";